// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import ReactGA from "react-ga4";

import EnergyBilling from '../User/Advisory/EnergyBilling'
import CommunityBilling from '../User/Advisory/CommunityBilling'
import AppliancesReplacement from '../User/Advisory/AppliancesReplacement'
import ConsumptionControl from '../User/Advisory/ConsumptionControl'
import AlternativeEnergySources from '../User/Advisory/AlternativeEnergySources'
import BatteriesInstallation from '../User/Advisory/BatteriesInstallation'
import AlternativeTransportation from '../User/Advisory/AlternativeTransportation'
import EnergySurplus from '../User/Advisory/EnergySurplus'
import PublicFeesAnalyzer from '../Public/PublicFeesAnalyzer.js'
import Connectivity from "../User/Advisory/Connectivity.js"
import Last12BillsAnalysis from '../Public/Last12BillsAnalysis.js'

import Loader from '../../components/Utils/Loader'

var generalCommonJS = require("../../js/generalCommon.js")

// CONFIGURACIÓN
const PublicAdvisory = (params) => {

  const [selectedAdvisoryOption, setSelectedAdvisoryOption] = useState("")  

  useEffect(() => {    
    
    document.title = "HELIAS - Asesoramiento"     
    try{
      document.querySelector('meta[name="description"]').setAttribute("content", "Aquí tienes una serie de consejos y herramientas para conseguir una máxima eficiencia energética y ahorro.");
    }
    catch(error){}

    if(params.selectedOption === undefined){
      window.history.pushState("", "", '/Asesoramiento')  
    }
    else{      
      seleccionarOpcionAdvisory(params.selectedOption)
    }

    document.getElementById("volverAsesoramientoPublico").className = document.getElementById("volverAsesoramientoPublico").className.replaceAll(" hidden", "")

    console.log("Página de asesoramiento general cargada correctamente.")
    
  }, [])

  function seleccionarOpcionAdvisory(opcion){

    document.body.scrollTop = document.documentElement.scrollTop = 0;    
    
    var componente = ""
    var tituloDetalle = ""
    var iconoDetalle = "" 

    if ((opcion === "") || (typeof(opcion) === "undefined")){
      componente = <EnergyBilling/>
      window.history.pushState("", "", '/Asesoramiento/Contrato-Luz')
      tituloDetalle  = "Contrato de luz"
      iconoDetalle = "offline_bolt"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESOR PUB. - '+tituloDetalle, "", "")
    }else{

      document.getElementById("divOpcionesAdvisory").className = document.getElementById("divOpcionesAdvisory").className.replace(" hidden", "") + " hidden"

      if(opcion === "EnergyBilling"){ 
        componente = <EnergyBilling seleccionarOpcionAdvisory={seleccionarOpcionAdvisory}/>
        window.history.pushState("", "", '/Asesoramiento/Contrato-Luz')
        tituloDetalle  = "Contrato de luz"
        iconoDetalle = "offline_bolt"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESOR PUB. - '+tituloDetalle, "", "")
      }
      else if(opcion === "FeesAnalyzer"){ 
        componente = <PublicFeesAnalyzer subOption={""}/>
        window.history.pushState("", "", '/Asesoramiento/Tarifas-Luz')
        tituloDetalle  = "Tarifas de luz"
        iconoDetalle = "euro"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESOR PUB. - '+tituloDetalle, "", "")
      }            
      else if(opcion === "CommunityBilling"){ 
        componente = <CommunityBilling seleccionarOpcionAdvisory={seleccionarOpcionAdvisory}/>
        window.history.pushState("", "", '/Asesoramiento/Comunidad-Vecinos')
        tituloDetalle  = "Comunidad de vecinos"
        iconoDetalle = "apartment"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESOR PUB. - '+tituloDetalle, "", "")
      }
      else if(opcion === "AlternativeEnergySources"){ 
        componente = <AlternativeEnergySources/>
        window.history.pushState("", "", '/Asesoramiento/Paneles-Solares')
        tituloDetalle  = "Paneles solares"
        iconoDetalle = "solar_power"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESOR PUB. - '+tituloDetalle, "", "")
      }
      else if(opcion === "BatteriesInstallation"){ 
        componente = <BatteriesInstallation/>
        window.history.pushState("", "", '/Asesoramiento/Baterias')
        tituloDetalle  = "Baterías"
        iconoDetalle = "battery_charging_full"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESOR PUB. - '+tituloDetalle, "", "")
      }
      else if(opcion === "AlternativeTransportation"){ 
        componente = <AlternativeTransportation/>        
        window.history.pushState("", "", '/Asesoramiento/Movilidad-Electrica')  
        tituloDetalle  = "Movilidad eléctrica"
        iconoDetalle = "electric_car"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESOR PUB. - '+tituloDetalle, "", "")
      }    
      else if(opcion === "ConsumptionControl"){ 
        componente = <ConsumptionControl/>        
        window.history.pushState("", "", '/Asesoramiento/Dispositivos-Inteligentes')  
        tituloDetalle  = "Dispositivos inteligentes"
        iconoDetalle = "devices_other"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESOR PUB. - '+tituloDetalle, "", "")
      }
      else if(opcion === "Connectivity"){ 
        componente = <Connectivity/>
        window.history.pushState("", "", '/Asesoramiento/Conectividad')          
        tituloDetalle  = "Conectividad"
        iconoDetalle = "wifi"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESOR PUB. - '+tituloDetalle, "", "")
      }
      else if(opcion === "AppliancesReplacement"){         
        componente = <AppliancesReplacement/>
        window.history.pushState("", "", '/Asesoramiento/Sustitucion-Electrodomesticos')  
        tituloDetalle  = "Sustitución de electrodomésticos"
        iconoDetalle = "microwave"                
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESOR PUB. - '+tituloDetalle, "", "")
      }
      else if(opcion === "EnergySurplus"){ 
        componente = <EnergySurplus/>
        window.history.pushState("", "", '/Asesoramiento/Excedente-Energetico')
        tituloDetalle  = "Excedente energético"
        iconoDetalle = "output"                
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'HELIAS PUBLICO', 'ASESOR PUB. - '+tituloDetalle, "", "")
      }      

    }

    document.getElementById("divContenedorDetalleAdvisory").className = document.getElementById("divContenedorDetalleAdvisory").className.replace(" hidden", "")
    document.getElementById("cabeceraAsesoramientoPublico").className = document.getElementById("cabeceraAsesoramientoPublico").className.replace(" hidden", "") + " hidden"

    document.getElementById("iconoDetalleAdvisory").innerHTML = iconoDetalle
    document.getElementById("tituloDetalleAdvisory").innerHTML = tituloDetalle

    document.title = "HELIAS - Asesoramiento: "+tituloDetalle

    setSelectedAdvisoryOption(componente)
  }

  function volverListadoAsesoramiento(){
    
    document.getElementById("divOpcionesAdvisory").className = document.getElementById("divOpcionesAdvisory").className.replace(" hidden", "")
    document.getElementById("divContenedorDetalleAdvisory").className = document.getElementById("divContenedorDetalleAdvisory").className.replace(" hidden", "") + " hidden"
    document.getElementById("cabeceraAsesoramientoPublico").className = document.getElementById("cabeceraAsesoramientoPublico").className.replace(" hidden", "")
    document.title = "HELIAS - Herramientas de asesoramiento"
    window.history.pushState("", "", '/Asesoramiento')      
    
  }

  return (

    <>

        <section id="seleccionOpcionAdvisory" className="step wrapper config gap-08">

          <div className="content-wrapper horizontal">

              <div id="divOpcionesAdvisory" className="vertical gap-06">  

                <div className="row">

                  <div id="advisoryContratoLuz" className="col-md-6 col-lg-4 pointer" onClick={() => seleccionarOpcionAdvisory("EnergyBilling")}>

                    <section className="publicwidget bubble advice" >
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureContratoLuz" className="avatar size-l pink"><span id="iconoContratoLuz" className="material-icon">offline_bolt</span></figure>
                          <h1 className="headline-03 fill">Contrato de luz</h1>                          
                        </div>
                        <p id="introContratoLuz">Consideraciones a tener en cuenta para reducir tu factura de luz.</p>
                      </div>
                      <button id="botonContratoLuz" className="link" >Veamos</button>
                    </section>

                  </div>

                  <div id="advisoryComunidadesVecinos" className="col-md-6 col-lg-4 pointer" onClick={() => seleccionarOpcionAdvisory("CommunityBilling")}>

                    <section className="bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureComunidadesVecinos" className="avatar size-l pink"><span id="iconoComunidadesVecinos" className="material-icon">apartment</span></figure>
                          <h1 className="headline-03 fill">Comunidad de vecinos</h1>                          
                        </div>
                        <p id="introComunidadesVecinos">Consideraciones a tener en cuenta para reducir tu factura de luz.</p>
                      </div>
                      <button id="botonComunidadesVecinos" className="link" >Comprobémoslo</button>
                    </section>

                  </div>  

                  <div id="advisoryAnalizadorTarifas" className="col-md-6 col-lg-4 pointer" onClick={() => seleccionarOpcionAdvisory("FeesAnalyzer")}>

                    <section className="bubble advice" >
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureAnalizadorTarifas" className="avatar size-l pink"><span id="iconoAnalizadorTarifas" className="material-icon">euro</span></figure>
                          <h1 className="headline-03 fill">Tarífas de luz</h1>                          
                        </div>
                        <p id="introAnalizadorTarifas">¿No sabes si tus tarifas de luz son buenas o malas?</p>
                      </div>
                      <button id="botonAnalizadorTarifas" className="link" >Veámoslo</button>
                    </section>

                  </div>

                  <div id="advisorySustitucionElectrodomesticos" className="col-md-6 col-lg-4 pointer" onClick={() => seleccionarOpcionAdvisory("AppliancesReplacement")}>

                    <section className="bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureSustitucionElectrodomesticos" className="avatar size-l pink"><span id="iconoSustitucionElectrodomesticos" className="material-icon">microwave</span></figure>
                          <h1 className="headline-03 fill">Sustitución de electrodomésticos</h1>                          
                        </div>
                        <p id="introSustitucionElectrodomesticos">El consumo de los electrodomésticos antiguos es altísimo, comprueba si necesitas sustituir alguno.</p>
                      </div>
                      <button id="botonSustitucionElectrodomesticos" className="link" >Veámoslo</button>
                    </section>

                  </div>  

                  <div id="advisoryControlConsumo" className="col-md-6 col-lg-4 pointer" onClick={() => seleccionarOpcionAdvisory("ConsumptionControl")}>

                    <section className="bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureControlConsumo" className="avatar size-l pink"><span id="iconoControlConsumo" className="material-icon">devices_other</span></figure>
                          <h1 className="headline-03 fill">Dispositivos inteligentes</h1>                          
                        </div>
                        <p id="introControlConsumo">Usar dispositivos inteligentes te servirá para ahorrar automatizando tareas, ayudando a controlar gastos innecesarios por descuidos.</p>
                      </div>
                      <button id="botonControlConsumo" className="link" >¿Cuáles me recomiendas?</button>
                    </section>

                  </div>

                  <div id="advisoryConectividad" className="col-md-6 col-lg-4 pointer" onClick={() => seleccionarOpcionAdvisory("Connectivity")}>

                    <section className="bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureControlConsumo" className="avatar size-l pink"><span id="iconoControlConsumo" className="material-icon">wifi</span></figure>
                          <h1 className="headline-03 fill">Conectividad</h1>                          
                        </div>
                        <p>¿Tienes problemas de conectividad con tus dispositivos o no sabes cómo llevar el WIFI a un sitio concreto de tu instalación?</p>
                      </div>
                      <button className="link">Sí, ¿cómo lo resuelvo?</button>
                    </section>

                  </div>

                  <div id="advisoryFuentesAlternativasEnergia" className="col-md-6 col-lg-4 pointer " onClick={() => seleccionarOpcionAdvisory("AlternativeEnergySources")}>

                    <section className="bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureFuentesAlternativasEnergia" className="avatar size-l pink"><span id="iconoFuentesAlternativasEnergia" className="material-icon">solar_power</span></figure>
                          <h1 className="headline-03 fill">Paneles solares</h1>                          
                        </div>
                        <p id="introFuentesAlternativasEnergia">¿Quieres que te ayude a ver si te interesa instalar paneles solares?</p>
                      </div>
                      <button id="botonFuentesAlternativasEnergia" className="link" >¡Por supuesto!</button>
                    </section>

                  </div>

                  <div id="advisoryAprovechamientoExcedenteEnergetico" className="col-md-6 col-lg-4 pointer" onClick={() => seleccionarOpcionAdvisory("EnergySurplus")}>

                    <section className="bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureAprovechamientoExcedenteEnergetico" className="avatar size-l pink"><span id="iconoAprovechamientoExcedenteEnergetico" className="material-icon">output</span></figure>
                          <h1 className="headline-03 fill">Excedente energético</h1>                          
                        </div>
                        <p id="introAprovechamientoExcedenteEnergetico">¿Le estás regalando tu excedente energético a tu compañía eléctrica y no sabes que hacer?</p>
                      </div>
                      <button id="botonAprovechamientoExcedenteEnergetico" className="link" >Sí, ¿qué hago?</button>
                    </section>

                  </div>

                  <div id="advisoryBaterias" className="col-md-6 col-lg-4 pointer" onClick={() => seleccionarOpcionAdvisory("BatteriesInstallation")}>

                    <section className="bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureInstalacionBaterias" className="avatar size-l pink"><span id="iconoInstalacionBaterias" className="material-icon">battery_charging_full</span></figure>
                          <h1 className="headline-03 fill">Baterías</h1>                          
                        </div>
                        <p id="introInstalacionBaterias">¿Quieres que te ayude a ver si te interesa instalar baterías?</p>
                      </div>
                      <button id="botonInstalacionBaterias" className="link" >¡Por supuesto!</button>
                    </section>

                  </div>

                  <div id="advisoryMediosAlternativosTransporte" className="col-md-6 col-lg-4 pointer" onClick={() => seleccionarOpcionAdvisory("AlternativeTransportation")}>

                    <section className="bubble advice">
                      <div className="vertical gap-04">
                        <div className="gap-03 horizontal vertical-center">
                          <figure id="figureMediosTransporteAlternativos" className="avatar size-l pink"><span id="iconoMediosTransporteAlternativos" className="material-icon">electric_car</span></figure>
                          <h1 className="headline-03 fill">Movilidad eléctrica</h1>                          
                        </div>
                        <p id="introMediosTransporteAlternativos">¿Te estás arruinando con tu coche gasolina / diesel / híbrido o estás pensando en comprarte otro coche eléctrico?</p>
                      </div>
                      <button id="botonMediosTransporteAlternativos" className="link" >Veamos alternativas</button>
                    </section>

                  </div>  

                </div>   
              </div>

              <div id="divContenedorDetalleAdvisory" className="page hidden">

                <div className="page">

                  <section id="detalleAdvisory" className="modal">

                    <button id="volverAsesoramientoPublico" className="link close" onClick={() => volverListadoAsesoramiento()}><span className="material-icon">arrow_back</span> Volver</button>

                    <div id="divDetalleAdvisory" className="vertical gap-08">

                      <header className="center">                                
                        <figure id="figureDetalleAdvisory" className="avatar size-xl pink">
                          <span id="iconoDetalleAdvisory" className="material-icon"></span>
                        </figure>
                        <dl className="vertical fill">
                          <dd id="tituloDetalleAdvisory" className="headline-02"></dd>
                        </dl>
                      </header>   

                      <div id="opcionSeleccionada" className="vertical gap-04">
                          {selectedAdvisoryOption}
                      </div>
                    
                    </div>
                    
                  </section>

                </div>

                <Loader Id="loaderDetalleAdvisory" Mensaje=""/>

                <div id="toastInformativo" className="toast" onClick={() => document.getElementById("toastInformativo").className = "toast invisible"}></div>

              </div>

          </div>

        </section>

        
      
    </>

  )
}

export default PublicAdvisory